import CamParallax from "./CamParallax.js"
import gsap from 'gsap'

class OscDisks {
  constructor() {
    this.bind()
  }

  generateDiskArray(mesh) {
    this.diskArray = new THREE.Group()
    const diskNum = 6
    for (let i = 0; i < diskNum; i++) {
      const dCloneHolder = new THREE.Object3D()
      const dClone = mesh.clone()
      dClone.scale.set(0, 0, 0)
      const targetScale = 2 + i * 0.7

      this.animTl.to(dClone.scale, {
        x: targetScale,
        y: 1,
        z: targetScale,
        duration: .3
      }, ((diskNum - 1) - i) * 0.1)
      // dClone.scale.set(targetScale, 1, targetScale)
      dClone.position.y = -i * 0.2
      dCloneHolder.add(dClone)
      this.diskArray.add(dCloneHolder)
    }

    this.diskArray.rotation.x = Math.PI / 2
    this.scene.add(this.diskArray)

  }

  init(scene) {
    this.scene = scene
    this.animTl = gsap.timeline({
      paused: true,
    })
    this.modelLoader = new THREE.GLTFLoader()
    this.mat = new THREE.MeshMatcapMaterial({
      matcap: new THREE.TextureLoader().load(webglAssets.ball)
    })

    this.modelLoader.load(webglAssets.disc, (glb) => {
      glb.scene.traverse(child => {
        if (child instanceof THREE.Mesh) {
          let mesh = child
          mesh.material = this.mat
          this.generateDiskArray(glb.scene.children[0])
        }
      })
    })
  }

  update(progress) {
    if (!this.diskArray) return
    let inc = 0
    while (inc < this.diskArray.children.length) {
      const child = this.diskArray.children[inc]
      const scale = 1 + (Math.sin(Date.now() * 0.0015 + inc * .5) + 1) / 20

      const intensityOffset = (this.diskArray.children.length - (inc + 1)) * 0.001
      child.position.x += (CamParallax.mousePos.x * intensityOffset - child.position.x) * 0.05
      child.position.z += (CamParallax.mousePos.y * intensityOffset - child.position.z) * 0.05
      child.scale.set(scale, 1, scale)
      inc++
    }

    if (this.animTl)
      this.animTl.time(Math.min(Math.max(progress - 4.5, 0), this.animTl.duration()))

  }


  bind() {
    this.generateDiskArray = this.generateDiskArray.bind(this)
    this.update = this.update.bind(this)
  }
}

const _instance = new OscDisks()
export default _instance
